<div class="relative">
  <!-- Floating label (optional) -->
  <label
    *ngIf="floatingLabel"
    class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-600 transition-all duration-200 peer-open:text-blue-600"
    [class.opacity-0]="!hasValue"
  >
    {{ label }}
  </label>

  <details
    #detailsElementRef
    class="group peer rounded border border-black bg-white px-3 py-3 transition-colors duration-200 open:border-blue-600 focus-within:border-blue-600"
  >
    <summary
      class="flex items-center justify-between cursor-pointer list-none outline-none"
      (click)="onSummaryClick($event)"
    >
      <span class="text-gray-400" *ngIf="!hasValue"> Select </span>

      <span class="selected-value text-gray-900 truncate" *ngIf="hasValue">
        {{ selectedLabel }}
      </span>

      <span
        class="ml-2 text-gray-500 transition-transform duration-200 group-open:rotate-180"
      >
        <img
          src="/assets/shared-icons/neptune-icon-black-chevron-down.svg"
          alt="expand-icon"
          class="flex w-5 h-5 self-center"
        />
      </span>
    </summary>

    <!-- Dropdown panel -->
    <div
      role="listbox"
      class="absolute left-0 right-0 z-50 max-h-48 overflow-y-auto rounded border border-gray-300 bg-white shadow-lg p-2"
      [ngClass]="{
        'top-[calc(100%+4px)]': dropdownOpenDirection === 'down',
        'bottom-[calc(100%+4px)]': dropdownOpenDirection === 'up',
      }"
    >
      <ng-container *ngIf="options.length > 0; else noOptions">
        <div
          *ngFor="let option of options"
          role="option"
          class="px-2 py-1.5 rounded cursor-pointer hover:bg-light-blue"
          [ngClass]="{
            'hover:bg-light-blue': true,
            'bg-light-blue': option === value,
          }"
          [attr.aria-selected]="option === value"
          (click)="selectOption(option)"
        >
          {{ displayFn(option) }}
        </div>
      </ng-container>
      <ng-template #noOptions>
        <div class="px-2 py-1.5 text-sm text-gray-900 text-center">
          <span class="text-sm w-full max-w-full text-center break-words">{{
            noOptionsMessage
          }}</span>
        </div>
      </ng-template>
    </div>
  </details>
</div>
